import {ServerResolutionResult} from 'notebook/tables/string-resolution/StringResolutionConstants';
import * as net from 'util/Net';

export function doValidateSmilesQuery(
  smilesList: Array<string>
): Promise<{serverResolutionResults: Array<ServerResolutionResult>}> {
  return net.postJSONPromise({
    url: '/1/api/eln:bulk-perform-smiles-validation',
    data: {
      smilesList,
    },
  });
}
